module.exports = __webpack_public_path__ + "937e0c70ed6db67c8ab8d99453c39e74.png";